// Keyboard focus for the shell (sidebar, tab bar, settings menu) and the Workbench pages: a solid
// 2px outline in the accent colour, never the browser's blue ring. #C2410C is about 5:1 against
// paper, panel, wash and surface, above the 3:1 WCAG 1.4.11 asks of a focus indicator.
// Kept in a .ts file under src/ so Tailwind still sees the full class names.

/** Outline just outside the element: buttons, links and controls with room around them. */
export const FOCUS =
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent'

/**
 * Outline just inside the element: rows in a list, a scrolling strip or a clipped card, where an
 * outer outline would be cut off or hidden under the neighbouring row.
 */
export const FOCUS_INSET =
  'focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-accent'
